import TournamentModule from '../../Components/Tournaments/TournamentModule'

const Tournament = () => <TournamentModule />

export default Tournament
